import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import ConfirmationModal from "features/ui/ConfirmationModal";

interface Props {
  isOpen: boolean;
  onClose: (confirmed: boolean) => void;
  entityName: string;
  name: string;
  text?: ReactNode;
  loading?: boolean;
  error?: string;
}

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  entityName,
  name,
  text,
  loading = false,
  error,
}: Props) => {
  const { t } = useTranslation();
  // Entity names come from Title Case labels such as "Tire Setting", but the
  // copy uses them mid-sentence.
  const entity = entityName.toLowerCase();

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title={t("common:delete.title", { entityName: entity })}
      text={text ?? t("common:delete.text", { entityName: entity, name })}
      confirmText={t("common:delete.action")}
      confirmColor="error"
      loading={loading}
      closeDisabled={loading}
      error={error}
    />
  );
};

export default DeleteConfirmationModal;
